import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

type StartOf = 'year' | 'month' | 'week' | 'isoWeek' | 'day' | 'date' | 'hour' | 'minute' | 'second';

export class DateValidators {
    public static max(maxDate: string, granularity: StartOf = null): ValidatorFn {
        return this.compareWith(maxDate, granularity, 'after', 'maxDate');
    }

    public static min(minDate: string, granularity: StartOf = null): ValidatorFn {
        return this.compareWith(minDate, granularity, 'before', 'minDate');
    }

    public static notEqual(date: string, granularity: StartOf = null): ValidatorFn {
        return this.compareWith(date, granularity, 'equal', 'equalDate');
    }

    private static compareWith(
        referenceDateStr: string,
        granularity: StartOf,
        operator: 'before' | 'after' | 'equal',
        errorKey: string
    ): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const controlDate = this.toDate(control.value);
            const referenceDate = this.toDate(referenceDateStr);

            if (!controlDate || !referenceDate) return null;

            const d1 = this.startOf(controlDate, granularity);
            const d2 = this.startOf(referenceDate, granularity);

            const isValid =
                operator === 'after' ? d1 <= d2 :
                    operator === 'before' ? d1 >= d2 :
                        d1.getTime() !== d2.getTime();

            return isValid ? null : { [errorKey]: referenceDate.toISOString() };
        };
    }
    private static toDate(value: any): Date | null {
        const date = new Date(value);
        return !isNaN(date.getTime()) ? date : null;
    }

    private static startOf(date: Date, granularity: StartOf): Date {
        const result = new Date(date);

        switch (granularity) {
            case 'year':
                result.setMonth(0, 1);
                result.setHours(0, 0, 0, 0);
                break;
            case 'month':
                result.setDate(1);
                result.setHours(0, 0, 0, 0);
                break;
            case 'week':
                const dayOfWeek = result.getDay();
                result.setDate(result.getDate() - dayOfWeek);
                result.setHours(0, 0, 0, 0);
                break;
            case 'day':
            case 'date':
                result.setHours(0, 0, 0, 0);
                break;
            case 'hour':
                result.setMinutes(0, 0, 0);
                break;
            case 'minute':
                result.setSeconds(0, 0);
                break;
            case 'second':
                result.setMilliseconds(0);
                break;
        }

        return result;
    }
}
